export default __webpack_public_path__ + "static/media/page-bg.30dc34c7.jpg";